import React, { Component } from 'react';

class First extends Component {
  render() {
    return (
      <p className="First-intro">
        Hello from <code>First</code>.
      </p>
    );
  }
}

export default First;



// WEBPACK FOOTER //
// ./src/components/Page/First/First.js